import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  ManyToOne,
  OneToMany,
  CreateDateColumn,
  UpdateDateColumn,
  JoinColumn,
  PrimaryColumn,
} from 'typeorm';

import {
  SalesStatus,
  SalesAttachmentsStatus,
  SalesQuarters,
} from '../../interface/sales/sales-response.interface';

import { UsersEntity } from '../users/user.entity';
import { MonitoringsEntity } from '../monitorings/monitorings.entity';
import { AttachmentsEntity } from '../attachments/attachments.entity';
import { CategoryTypes } from '../../utils/enums.utils';

@Entity('sales')
export class SalesEntity {
  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column({ type: 'varchar' })
  quarter!: SalesQuarters;

  @Column({ type: 'varchar' })
  status!: SalesStatus;

  @Column({ type: 'varchar' })
  category!: CategoryTypes;

  @Column({ nullable: true })
  po_number?: string | null;

  @Column({ nullable: true })
  invoice_number?: string | null;

  @Column({ nullable: true })
  dr_number?: string | null;

  @Column({ type: 'text', nullable: true })
  sales_remark?: string | null;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  // Relations: Users
  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by_id' })
  created_by?: UsersEntity | null;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by_id' })
  updated_by?: UsersEntity | null;

  // Relation: Monitoring (required)
  @ManyToOne(() => MonitoringsEntity, { nullable: false })
  @JoinColumn({ name: 'monitoring_id' })
  monitoring!: MonitoringsEntity;

  // Relation: Sale Attachments
  @OneToMany(() => SaleAttachmentsEntity, attachment => attachment.sale, { cascade: true })
  attachments?: SaleAttachmentsEntity[];
}

@Entity('sales_attachments')
export class SaleAttachmentsEntity {
  // Foreign key column for SalesEntity
  @PrimaryColumn('uuid', { name: 'sales_id' })
  sales_id!: string;

  @ManyToOne(() => SalesEntity, sale => sale.attachments, {
    nullable: false,
    onDelete: 'CASCADE',
  })
  @JoinColumn({ name: 'sales_id' })
  sale!: SalesEntity;

  // Foreign key column for AttachmentsEntity
  @PrimaryColumn('uuid', { name: 'attachment_id' })
  attachment_id!: string;

  @ManyToOne(() => AttachmentsEntity, { nullable: false })
  @JoinColumn({ name: 'attachment_id' })
  attachment!: AttachmentsEntity;

  @Column({ type: 'enum', enum: SalesAttachmentsStatus })
  status!: SalesAttachmentsStatus;
}